import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';

import {
	Box,
	Button,
	Heading,
	HStack,
	FormControl,
	FormLabel,
	Input,
	Link,
	Stack,
	Tabs,
	TabList,
	TabPanels,
	Tab,
	TabPanel,
	Tooltip,
} from '@chakra-ui/react';
import { CopyIcon, ExternalLinkIcon } from '@chakra-ui/icons';

import { getAge } from '../app-data/date';
import { docTitles, initialStructured, options } from './data';
import { Communications } from './communications';
import { Profile } from './profile';
import { Checklist } from './checklist';
import { Process } from './process';

export const User = ({ user: { id } }) => {
	const [loading, setLoading] = useState(true);
	const [user, setUserState] = useState({});
	const [agreement, setAgreement] = useState([]);
	const [wake, setWakeState] = useState(0);
	const [wakeProcess, setWakeProcess] = useState(0);
	const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
	const [file, setFile] = useState(null);

	useEffect(() => {
		let active = true;
		async function load() {
			const res = await axios.get(`/users/${id}`, options());
			const agmt = await axios.get(`/user-agreement/${id}`, options());
			if (!active) {
				return;
			}
			let { structured } = res.data.user;
			console.log('one', structured)
			structured =
				Object.keys(structured).length === 6 ? structured : initialStructured;
			console.log('two', structured)
			setAgreement(agmt.data.agreement);
			setUserState({
				...res.data.user,
				structured,
				age: getAge(res.data.user.birth_date),
			});
			setLoading(false);
		}
		load();

		return () => {
			active = false;
		};
	}, [id, wake]);

	const setWake = date => {
		setWakeState(date);
		setIsSubmitDisabled(true);
	};

	const setUser = user => {
		setUserState(user);
		setIsSubmitDisabled(false);
	};

	const handleFileChange = e => setFile(e.target.files[0]);
	const upload = () => {
		const formData = new FormData();
		formData.append('id', id);
		formData.append('file', file);
		const config = {
			headers: {
				'content-type': 'multipart/form-data',
				...options().headers,
			},
		};
		return axios
			.post('/agreement', formData, config)
			.then(() => setWakeState(new Date()));
	};

	if (loading) return <p>Loading...</p>;

	let { firstName, lastName, loaded, service, stage, status, storage_link } =
		user;
	service = service || 'cons';
	console.log()

	return (
		<Box p={4}>
			<Heading
				pb={12}
				fontSize={'3xl'}
				sx={{
					'@media print': {
						display: 'none',
					},
				}}
			>{`${firstName} ${lastName}`}</Heading>
			<Tabs isFitted variant="enclosed">
				<TabList
					sx={{
						'@media print': {
							display: 'none',
						},
					}}
				>
					<Tab>
						<Box onClick={() => setWakeProcess(new Date())}>Process</Box>
					</Tab>
					<Tab>
						<Box onClick={() => setWake(new Date())}>Profile</Box>
					</Tab>
					<Tab>
						<Box onClick={() => setWake(new Date())}>Documents</Box>
					</Tab>
					<Tab>
						<Box onClick={() => setWake(new Date())}>Communications</Box>
					</Tab>
				</TabList>

				<TabPanels>
					<TabPanel>
						<Process {...{ service, stage: false, wakeProcess }} />
						{false && String(stage) === '2' && (
							<Box pb={6}>
								<Heading pt="6" fontSize={'2xl'}>
									Рабочие материалы
								</Heading>
								<HStack pt={6}>
									<Button w="33%" leftIcon={<CopyIcon />} colorScheme="teal">
										Пример imm5257e
									</Button>
									<Button w="33%" leftIcon={<CopyIcon />} colorScheme="teal">
										Пример imm5257b_1
									</Button>
									<Button w="33%" leftIcon={<CopyIcon />} colorScheme="teal">
										Пример imm5476e
									</Button>
								</HStack>
								<HStack pt={6}>
									<Button w="33%" leftIcon={<CopyIcon />} colorScheme="teal">
										Пример imm1294e
									</Button>
									<Button w="33%" leftIcon={<CopyIcon />} colorScheme="teal">
										Пример imm1295e
									</Button>
									<Button w="33%" leftIcon={<CopyIcon />} colorScheme="teal">
										Пример imm5645e
									</Button>
								</HStack>
								<HStack pt={6}>
									<Link isExternal>
										<b>imm1294e</b> — заполняют все, кто подается на study
										permit, и взрослый и дети, которые идут в школу{' '}
										<ExternalLinkIcon mx="2px" />
									</Link>
								</HStack>
								<HStack pt={6}>
									<Link isExternal>
										<b>imm1295e</b> — заполняет супруг, который подается на
										разрешение на работу <ExternalLinkIcon mx="2px" />
									</Link>
								</HStack>
								<HStack pt={6}>
									<Link isExternal>
										<b>imm5257b_1</b> — заполняют все взрослые{' '}
										<ExternalLinkIcon mx="2px" />
									</Link>
								</HStack>
								<HStack pt={6}>
									<Link isExternal>
										<b>imm5257e</b> — заполняется на ребенка, если он не идет в
										школу <ExternalLinkIcon mx="2px" />
									</Link>
								</HStack>
								<HStack pt={6}>
									<Link isExternal>
										<b>imm5707e</b> — заполняется на каждого подающегося{' '}
										<ExternalLinkIcon mx="2px" />
									</Link>
								</HStack>
							</Box>
						)}
					</TabPanel>
					<TabPanel>
						<Profile {...{ user, setUser, setWake, isSubmitDisabled }} />
					</TabPanel>
					<TabPanel>
						{service === 'cons' ? (
							<>
								{agreement.length > 0 && (
									<Heading pb={6} fontSize={'lg'}>
										{`Файл «${agreement[0].name}» загружен ${moment(
											agreement[0].updated_at
										).format('HH:mm DD.MM.YYYY')}`}
									</Heading>
								)}
								<Stack pb={6} direction={['column', 'row']}>
									<FormControl>
										<Tooltip
											placement="top-start"
											label="Пожалуйста загрузите скан подписанного соглашения на консультацию"
										>
											<FormLabel>
												Please upload a valid scan of signed consultation
												agreement
											</FormLabel>
										</Tooltip>
										<Input type="file" onChange={handleFileChange} />
									</FormControl>
									<FormControl>
										<FormLabel>&nbsp;</FormLabel>
										<Button colorScheme="blue" onClick={upload}>
											Upload
										</Button>
									</FormControl>
								</Stack>
							</>
						) : (
							<>
								<Tooltip
									label="Прикрепите существенные документы, на которые обязательно стоит посмотреть во время консультации"
									placement="bottom-start"
								>
									<Heading pb={6} fontSize={'xl'}>
										{docTitles[service]}
									</Heading>
								</Tooltip>
								{storage_link && (
									<Tooltip
										label="Загружайте документы в Google Drive по этой ссылке, используйте структуру папок верно"
										placement="bottom-start"
									>
										<Link
											href={storage_link}
											target="_blank"
											d="block"
											w="100%"
											bgColor="blue.500"
											borderRadius="md"
											color="white"
											fontSize="xl"
											py="2"
											textAlign="center"
											_hover={{
												textDecoration: 'none',
											}}
											sx={{
												'@media print': {
													display: 'none',
												},
											}}
										>
											Upload your documents to the Google Drive with this link.
											Use folders structure correctly
										</Link>
									</Tooltip>
								)}
								<Checklist
									{...{ customer: id, loaded, wake, setWake, service, stage }}
								/>
							</>
						)}
					</TabPanel>
					<TabPanel>
						<Communications {...{ id, status, wake }} />
					</TabPanel>
				</TabPanels>
			</Tabs>
		</Box>
	);
};
